import { useTranslation } from 'react-i18next';
import * as diapoPresStyles from '../../../styles/internal-page/diapoPres.module.scss';
import 'swiper/css';
import 'swiper/css/pagination';
import PropTypes from 'prop-types';
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import IconContainer from '../IconContainer';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import SwiperCore, { Navigation } from 'swiper';
import clsx from 'clsx';

SwiperCore.use([Navigation]);

const DiapoPres = ({
  content,
}) => {
  const {t} = useTranslation();
  const paginationRef = React.useRef(null);
  const [swiper, setSwiper] = React.useState(null);
  const [display, setDisplay] = React.useState(false);

  React.useEffect(() => {
    setDisplay(true);
  }, []);

  if (!content.testimonies || content.testimonies.length === 0) {
    return null;
  }

  if (content.testimonies.length === 1){
    return (
      <div className={diapoPresStyles.container}>
        {content.testimonies[0].picture &&
          <div className={diapoPresStyles.containerImage}>
            <GatsbyImage
              alt={''}
              className={diapoPresStyles.image}
              image={getImage(content.testimonies[0].picture?.imageFile)}
              loading="eager"
            />
          </div>
        }
        <div className={diapoPresStyles.containerText}>
          {content.testimonies[0].children}
        </div>
      </div>
    );
  }
  return (
    <div className={diapoPresStyles.root}>
      <div className={diapoPresStyles.thumbnailMargin}>
        <ul
          aria-label={t('carrousel.chips')}
          ref={paginationRef}
          style={{display: 'flex', width: 'auto'}}
        >
        </ul>
      </div>
      {display &&
      <button
        aria-label={t('carrousel.leftArrow')}
        className={diapoPresStyles.leftArrowDiaporamaTest}
        onClick={() => {
          swiper.slidePrev();
        }}
        onKeyDown={(e) => {
          e.currentTarget.click();
        }}
        tabIndex="0"
      >
        <IconContainer
          color="RED"
          icon="ARROW_LEFT_LARGE"
          size={20}
          svgClassname={diapoPresStyles.svg}
          variant="contained"
        />
      </button>}
      {display &&
      <button
        aria-label={t('carrousel.rightArrow')}
        className={diapoPresStyles.rightArrowDiaporamaTest}
        onClick={() => {
          swiper.slideNext();
        }}
        onKeyDown={(e) => {
          e.currentTarget.click();
        }}
        tabIndex="0"
      >
        <IconContainer
          color="RED"
          icon="ARROW_RIGHT_LARGE"
          size={20}
          svgClassname={diapoPresStyles.svg}
          variant="contained"
        />
      </button>}
      <Swiper
        autoHeight
        centeredSlides
        className={clsx({[diapoPresStyles.inLoadContainer]: !display})}
        loop
        onSwiper={(core) => setSwiper(core)}
        pagination={{
          el: paginationRef.current,
          clickable: true,
          bulletElement: 'li',
          bulletClass: diapoPresStyles.thumbnails,
          bulletActiveClass: diapoPresStyles.thumbnailsActive,
        }}
        slidesPerView={1}
        spaceBetween={2}
        speed={600}
        style={{width: '100%'}}
      >
        {content?.testimonies?.map((item, index) => (
          <SwiperSlide
            key = {index}
          >
            <div className={diapoPresStyles.container}>
              {item.picture &&
                <div className={diapoPresStyles.containerImage}>
                  <GatsbyImage
                    alt={''}
                    className={diapoPresStyles.image}
                    image={getImage(item.picture?.imageFile)}
                    loading="eager"
                  />
                </div>
              }
              <div className={diapoPresStyles.containerText}>
                {item.children}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

DiapoPres.propTypes = {
  content: PropTypes.shape({
    testimonies: PropTypes.arrayOf(PropTypes.shape({
      aria_label: PropTypes.string,
      title: PropTypes.string,
      subtitle: PropTypes.string,
      picture: PropTypes.shape({
        imageFile: PropTypes.object
      }),
      children: PropTypes.node,
    })).isRequired,
  }).isRequired,
};

export default DiapoPres;
